const AccountType = {
  KEY: 1,
  STANDARD: 2,
  LIMITED: 3
}

export default AccountType;
